import passwordRules from "@/utils/validatePassword";

/**
 * Reference: https://github.com/wearebraid/vue-formulate-i18n/blob/master/src/locales/en.js
 * This is an object of functions that each produce valid responses. There's no
 * need for these to be 1-1 with english, feel free to change the wording or
 * use/not use any of the variables available in the object or the
 * arguments for the message to make the most sense in your language and culture.
 *
 * The validation context object includes the following properties:
 * {
 *   args        // Array of rule arguments: between:5,10 (args are ['5', '10'])
 *   name:       // The validation name to be used
 *   value:      // The value of the field (do not mutate!),
 *   vm: the     // FormulateInput instance this belongs to,
 *   formValues: // If wrapped in a FormulateForm, the value of other form fields.
 * }
 */
const localizedValidationMessages = {
  passwordHasLength: () =>
    `Wachtwoord moet ten minste ${passwordRules.requiredPasswordLength} karakters zijn.`,
  passwordHasNumber: () =>
    `Wachtwoord moet ten minste ${passwordRules.requiredNumbers} cijfer${
      passwordRules.requiredNumbers > 1 ? "s" : ""
    } hebben.`,
  passwordHasSpecial: () =>
    `Wachtwoord moet ten minste ${
      passwordRules.requiredSpecialChars
    } speciale karakter${
      passwordRules.requiredSpecialChars > 1 ? "s" : ""
    } hebben.`,
  passwordHasUppercase: () =>
    `Wachtwoord moet ten minste ${
      passwordRules.requiredUppercaseChars
    } hoofdletter${
      passwordRules.requiredUppercaseChars > 1 ? "s" : ""
    } hebben.`,
  passwordHasLowercase: () =>
    `Wachtwoord moet ten minste ${
      passwordRules.requiredLowercaseChars
    } kleine letter${
      passwordRules.requiredLowercaseChars > 1 ? "s" : ""
    } hebben.`,
  passwordConfirm: () => "Wachtwoorden zijn niet gelijk.",
};

export default localizedValidationMessages;
